import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, CheckCircle, ArrowRight, Shield } from "lucide-react";

const sealItems = [
  "Roofline gaps and damaged fascia",
  "Soffit penetrations",
  "Foundation vents and crawl space openings",
  "Plumbing and electrical entry points",
  "Chimney caps and ridge vents",
  'Any gap larger than a half inch — because that\'s all a rat needs',
];

export default function RepairsPage() {
  useEffect(() => {
    document.title = "Seal-Offs & Exclusion Repairs | Double D Trapping LLC | St. Augustine, FL";
  }, []);

  return (
    <>
      {/* Header */}
      <section className="bg-[#0F1A15] border-b border-[#1F2937] py-16 sm:py-20" data-testid="repairs-page-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#D95D39] uppercase text-xs font-bold tracking-[0.2em] mb-4">Repairs & Exclusion</p>
          <h1 className="text-[#F8FAFC] font-black text-4xl sm:text-5xl tracking-tighter mb-4" data-testid="repairs-page-title">
            Seal-Offs & Exclusion Repairs
          </h1>
          <p className="text-[#9CA3AF] text-base sm:text-lg max-w-2xl leading-relaxed">
            The Trap Is Set. The Animal Is Gone. Now Let's Make Sure It Never Happens Again.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-[#0B110E] py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#9CA3AF] text-base sm:text-lg leading-relaxed mb-12">
            Removal without exclusion is just a temporary fix. Animals are creatures of habit — if the hole is still there, another one will find it. We do a full sweep of your home, find every gap, crack, and opening — and we seal them properly.
          </p>

          <h2 className="text-[#F8FAFC] font-black text-2xl sm:text-3xl tracking-tighter mb-8">
            What We Seal
          </h2>
          <div className="space-y-4 mb-12">
            {sealItems.map((item, i) => (
              <div key={i} className="flex items-start gap-3 border border-[#1F2937] rounded-sm p-4 sm:p-5 bg-[#0F1A15]">
                <CheckCircle className="w-5 h-5 text-[#D95D39] shrink-0 mt-0.5" />
                <span className="text-[#F8FAFC] text-sm sm:text-base">{item}</span>
              </div>
            ))}
          </div>

          {/* Guarantee */}
          <div className="border border-[#D95D39]/30 rounded-sm p-8 sm:p-10 bg-[#D95D39]/5" data-testid="repairs-guarantee">
            <div className="flex items-start gap-4">
              <Shield className="w-10 h-10 text-[#D95D39] shrink-0" />
              <div>
                <h3 className="text-[#F8FAFC] font-black text-xl sm:text-2xl tracking-tight mb-3">
                  The Double D Promise
                </h3>
                <p className="text-[#9CA3AF] text-sm sm:text-base leading-relaxed">
                  Our seal-offs come with a guarantee. If something gets back in through a point we sealed — we come back. That's the Double D promise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#0F1A15] border-t border-[#1F2937] py-16 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-[#F8FAFC] font-black text-2xl sm:text-3xl tracking-tighter mb-4">
            Let's Seal Your Home
          </h2>
          <p className="text-[#9CA3AF] text-sm sm:text-base mb-8">
            Get a free inspection and quote. We'll find every entry point and seal it right.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="tel:9042376253" data-testid="repairs-call-btn">
              <button className="bg-[#D95D39] hover:bg-[#c04d2d] text-white font-black uppercase tracking-widest text-sm px-8 py-4 rounded-sm btn-glow inline-flex items-center gap-3 transition-colors duration-150">
                <Phone className="w-5 h-5" /> Call 904-237-6253
              </button>
            </a>
            <Link to="/contact" data-testid="repairs-quote-btn">
              <button className="border border-[#1F2937] hover:border-[#D95D39] text-[#F8FAFC] font-bold uppercase tracking-widest text-sm px-8 py-4 rounded-sm inline-flex items-center gap-3 transition-colors duration-150">
                Get a Free Quote <ArrowRight className="w-4 h-4" />
              </button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
